<template>
  <div class="house-importer-import-charges-stage-charges-parameters-panel">
    <app-panel title="Заполнение параметров проверки начислений">

<!--      <template>-->
<!--        <div style="text-align: center">-->
<!--          Получаю тарифы-->
<!--        </div>-->
<!--      </template>-->

      <template>
        <div class="house-importer-import-charges-stage-charges-parameters-panel__row">
          <app-datepicker label="Месяц на который генерились начисления" format="MMMM yyyy" minimum-view="month" v-model="month"/>
        </div>

        <div class="house-importer-import-charges-stage-charges-parameters-panel__row">
          <app-v-select :options='[{id: 0, name: "жилое"}, {id: 1, name: "апартаменты"}, {id: 2, name: "коммерческое"}, {id: 3, name: "паркинг"}]' :reduce="option => option.id" use-dynamic-key
                        :clearable="false"
                        :searchable="false" v-model="apartmentsTypeModel" style="width: 100%"
                        label="Тип помещения" select-label="name"/>
        </div>

        <div class="house-importer-import-charges-stage-charges-parameters-panel__row" v-for="(tariffName, index) in tariffsNames" :key="`row-${index}`">
          <ChangeTariffsRow :tariffs="tariffs" class="" :value="tariffName" :tariffsNames="tariffsNames" @input="setTariffName($event, index)" @delete="deleteTariffName(index)"/>
        </div>

        <div class="house-importer-import-charges-stage-charges-parameters-panel__add-tariff">
          <div class="link-icon house-importer-import-charges-stage-charges-parameters-panel__add-tariff-text" @click="addTariffName">Добавить тариф</div>
        </div>

        <div class="house-importer-import-charges-stage-charges-parameters-panel__actions">
          <app-button color="success" :disabled="isSending" @click="sendParameters">{{isSending ? 'Сохраняю...' : 'Сохранить'}}</app-button>
        </div>
      </template>





    </app-panel>
  </div>
</template>

<script>
  import ChangeTariffsRow from "../components/ChangeTariffsRow";

  export default {
    name: "ChargesParameters",
    components: {
      ChangeTariffsRow
    },
    props: {
      importInfo: {},
      tariffs: {},
      apartmentsType: {}
    },
    data(){
      return {
        isSending: false,
        isTariffsLoading: true,
        tariffsNames: [],
        month: new Date(),
      }
    },
    computed: {
      apartmentsTypeModel: {
        get(){
          return this.apartmentsType;
        },
        set(v){
          this.$emit('update:apartmentsType', v);
        }
      },
    },
    methods: {
      async sendParameters(){
        this.isSending = true;
        try{
          let params = {
            import_id: this.importInfo.id,
            month: this.$options.filters.moment(this.month, 'YYYY-MM'),
            elsa_tarifs_ids: JSON.stringify(this.tariffsNames.map(v => v.elsa_name)),
            kvartal_tarifs: JSON.stringify(this.tariffsNames.map(v => v.kvartal_name)),
            apartments_type: this.apartmentsType,
          };

           let {data} = await this.$http.post('import/houses/check_charges', params);

           if(data === 'done'){
             this.$vs.notify({color: 'success', title: 'Успешное сохранение', text: 'Параметры сохранены'});
           }
           else{
             this.$vs.notify({color: 'danger', title: 'UNKNOWN ANSWER', text: data});
           }
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
        finally {
          setTimeout(() => { this.isSending = false}, 300);
        }
      },
      addTariffName(){
        let tariffName = {
          elsa_name: null,
          kvartal_name: null
        };
        this.tariffsNames.push(tariffName);
      },
      setTariffName(v, index){
        this.$set(this.tariffsNames, index, v);
      },
      deleteTariffName(index){
        this.tariffsNames.splice(index, 1);
      },
    },
    mounted() {
      if(this.importInfo.files_parameters && this.importInfo.files_parameters.charges_check){
        this.$nextTick(() => {
          this.month = this.$parseDateFromString(this.importInfo.files_parameters.charges_check.month);

          this.importInfo.files_parameters.charges_check.elsa_tarifs.forEach((key, i) => {
            this.tariffsNames.push({
              elsa_name: this.importInfo.files_parameters.charges_check.elsa_tarifs[i],
              kvartal_name: this.importInfo.files_parameters.charges_check.kvartal_tarifs[i]
            });
          });
        });
      }
    }
  }
</script>

<style lang="scss">
  .house-importer-import-charges-stage-charges-parameters-panel{

    &__row{
      margin-bottom: 15px;
    }

    &__add-tariff{
      margin-bottom: 15px;
      text-align: center;

      &-text{
        display: inline-block;
        font-size: 12px;
      }
    }

    &__actions{
      display: flex;
      align-items: center;
      justify-content: center;
    }

  }
</style>
